import React from "react"
import Img from "gatsby-image"
import classnames from "classnames"

const ImagePageTitle = ({
  title,
  fluidImage,
  type,
  tagText,
  className,
  imgTitle,
  imgAlt,
  category,
  remainBr,
  boxContent,
}) => {
  return (
    <div className={classnames("image-page-title", className)}>
      {type !== "yellow" && (
        <div className="image-page-title__category">{category}</div>
      )}
      <div
        className={classnames({
          "image-page-title__color-block": true,
          "image-page-title__color-block--yellow": type === "yellow",
          "image-page-title__color-block--grey": type === "grey",
        })}
      >
        <div className="image-page-title__color-block__img">
          <Img fluid={fluidImage} alt={imgAlt} title={imgTitle}></Img>
          {/* {tagText && (
            <div className="image-page-title__color-block__img__tag">
              {tagText}
            </div>
          )} */}
          {tagText &&
            tagText.map((tag, index) => (
              <div
                className={classnames({
                  "image-page-title__color-block__img__tag": true,
                  [`image-page-title__color-block__img__tag--${
                    index + 1
                  }`]: true,
                })}
              >
                {tag}
              </div>
            ))}
        </div>
      </div>
      {boxContent && (
        <div className="image-page-title__box-content">
          <div className="image-page-title__box-content__inner">
            {boxContent}
          </div>
        </div>
      )}
      <h1
        className={classnames({
          "image-page-title__title": true,
          "image-page-title__title--yellow": type === "yellow",
          "image-page-title__title--grey": type === "grey",
          "image-page-title__title--br": remainBr,
          "image-page-title__title--left": boxContent ? true : false,
        })}
        dangerouslySetInnerHTML={{ __html: title }}
      ></h1>
    </div>
  )
}

export default ImagePageTitle
